// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-profile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.7);
  backdrop-filter: blur(10px);
  z-index: 2000;
  display: flex;
  justify-content: flex-end;
}

.user-profile-panel {
  width: 440px;
  height: 100vh;
  background-color: var(--bg-primary);
  border-left: 1px solid var(--glass-border);
  display: flex;
  flex-direction: column;
  box-shadow: -20px 0 50px rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
}

.user-profile-panel::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.1), transparent);
  z-index: 100;
}

.profile-content-scrollable {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: none;
  position: relative;
}

.profile-content-scrollable::-webkit-scrollbar {
  display: none;
}

.profile-header {
  position: relative;
  height: 180px;
  width: 100%;
}

.profile-banner {
  width: 100%;
  height: 100%;
  background-color: var(--bg-tertiary);
  overflow: hidden;
  position: relative;
}

.banner-gradient {
  width: 100%;
  height: 100%;
  position: relative;
}

.banner-gradient::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent, var(--bg-primary));
}

.profile-close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-normal);
  z-index: 500;
}

.profile-close-btn:hover {
  background-color: var(--brand-primary);
  transform: rotate(90deg) scale(1.1);
}

.avatar-positioning {
  margin-top: -70px;
  margin-bottom: 28px;
  padding: 0 32px;
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.profile-badges-box {
  display: flex;
  gap: 8px;
  padding-bottom: 12px;
}

.profile-badge-item {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: help;
  transition: all 0.2s;
  background-color: rgba(255, 255, 255, 0.05);
}

.profile-badge-item:hover {
  transform: translateY(-2px);
  filter: brightness(1.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}


.profile-avatar-container {
  width: 140px;
  height: 140px;
  position: relative;
}

.avatar-main {
  width: 100%;
  height: 100%;
  border-radius: 40px;
  background: var(--bg-primary);
  border: 6px solid var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: 56px;
  font-weight: 900;
  color: var(--brand-light);
  box-shadow: var(--shadow-xl);
}

.status-pill-large {
  position: absolute;
  bottom: 12px;
  right: 0px;
  width: 32px;
  height: 32px;
  border-radius: 12px;
  border: 6px solid var(--bg-primary);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.profile-info-card {
  display: flex;
  flex-direction: column;
  padding: 0 32px 40px;
}

.name-and-tag {
  margin-bottom: 12px;
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.display-name {
  font-size: 28px;
  font-weight: 900;
  color: var(--text-primary);
}

.discriminator {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-muted);
  opacity: 0.5;
}

.status-quote {
  background-color: var(--bg-secondary);
  border-left: 4px solid var(--brand-primary);
  padding: 16px 20px;
  border-radius: 6px 16px 16px 6px;
  margin-bottom: 28px;
}

.profile-actions-row {
  display: flex;
  gap: 14px;
  margin-bottom: 40px;
}

.primary-action-btn {
  flex: 1;
  height: 48px;
  background-color: var(--brand-primary);
  border: none;
  border-radius: 14px;
  color: white;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.secondary-action-btn {
  width: 48px;
  height: 48px;
  background-color: var(--bg-secondary);
  border: 1px solid var(--glass-border);
  border-radius: 14px;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-divider {
  height: 1px;
  background: linear-gradient(to right, var(--glass-border), transparent);
  margin: 20px 0;
}

.profile-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-label {
  font-size: 11px;
  font-weight: 900;
  color: var(--brand-primary);
  letter-spacing: 2px;
  text-transform: uppercase;
}

.activity-widget {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 16px;
  margin-top: 10px;
}

.activity-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.activity-icon-box {
  color: #1db954; /* Spotify Green */
  display: flex;
  align-items: center;
}

.activity-title {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #f8fafc;
}

.activity-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.activity-name {
  font-weight: 900;
  font-size: 16px;
  color: #ffffff;
}

.activity-sub {
  font-size: 14px;
  color: #e2e8f0;
}

.activity-state {
  font-size: 13px;
  color: #94a3b8;
}

.activity-progress-area {
  margin-top: 12px;
}

.progress-track {
  height: 4px;
  background: #334155;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background: #1db954;
  border-radius: 2px;
}

.progress-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-family: 'JetBrains Mono', monospace;
  color: #94a3b8;
}


.profile-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.meta-item {
  padding: 16px;
  background-color: var(--bg-tertiary);
  border: 1px solid var(--glass-border);
  border-radius: 16px;
}

.meta-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.meta-label {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--text-muted);
  opacity: 0.7;
}

.meta-value {
  font-size: 13px;
  font-weight: 800;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-note-pad {
  height: 100px;
  background-color: var(--bg-tertiary);
  border: 1px solid var(--glass-border);
  border-radius: 16px;
  padding: 16px;
}

/* User Card Connections styling */
.profile-connections-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.profile-connection-pill {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
  border: 1px solid var(--glass-border);
  transition: all var(--transition-fast);
}

.profile-connection-pill:hover {
  background: var(--bg-modifier-hover);
  transform: translateY(-1px);
}

.profile-connection-pill .platform-name {
  font-weight: 750;
  font-size: 13px;
  color: var(--text-primary);
}

.profile-connection-pill .platform-user {
  margin-left: auto;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

/* Platform Colors for Icons */
.profile-connection-pill.spotify {
  border-left: 3px solid #1db954;
}
.profile-connection-pill.spotify svg {
  color: #1db954;
}

.profile-connection-pill.soundcloud {
  border-left: 3px solid #ff5500;
  background: rgba(255, 85, 0, 0.08);
}
.profile-connection-pill.soundcloud:hover {
  background: rgba(255, 85, 0, 0.16);
  transform: translateY(-1px);
}
.profile-connection-pill.soundcloud svg {
  color: #ff5500;
}

.profile-connection-pill.steam {
  border-left: 3px solid #66c0f4;
}
.profile-connection-pill.steam svg {
  color: #66c0f4;
}

.profile-connection-pill.epic {
  border-left: 3px solid #ffffff;
}
.profile-connection-pill.epic svg {
  color: #ffffff;
}

.profile-connection-pill.flexable {
  border-left: 3px solid #8b5cf6;
  background: rgba(139, 92, 246, 0.1);
  transition: all 0.2s ease;
}
.profile-connection-pill.flexable:hover {
  background: rgba(139, 92, 246, 0.2);
  transform: translateY(-1px);
}
.profile-connection-pill.flexable svg {
  color: #a78bfa;
}

.profile-connection-pill.discord {
  border-left: 3px solid #5865f2;
  background: rgba(88, 101, 242, 0.08);
  transition: all 0.2s ease;
}
.profile-connection-pill.discord:hover {
  background: rgba(88, 101, 242, 0.16);
  transform: translateY(-1px);
}
.profile-connection-pill.discord svg {
  color: #5865f2;
}

/* Lanyard Discord Activity Widget */
.lanyard-discord-widget {
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(88, 101, 242, 0.16) 0%, rgba(15, 23, 42, 0.85) 100%);
  border: 1px solid rgba(88, 101, 242, 0.35);
  box-shadow: 0 4px 18px rgba(88, 101, 242, 0.12);
  padding: 12px 14px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
}

.lanyard-discord-widget:hover {
  border-color: rgba(88, 101, 242, 0.55);
}

.lanyard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.lanyard-title-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.8px;
  color: #5865f2;
  text-transform: uppercase;
}

.lanyard-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.lanyard-status-pill.online {
  background: rgba(34, 197, 94, 0.18);
  color: #22c55e;
}
.lanyard-status-pill.idle {
  background: rgba(234, 179, 8, 0.18);
  color: #eab308;
}
.lanyard-status-pill.dnd {
  background: rgba(239, 68, 68, 0.18);
  color: #ef4444;
}
.lanyard-status-pill.offline {
  background: rgba(148, 163, 184, 0.18);
  color: #94a3b8;
}

/* User Profile Handle and Status Pill */
.display-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.handle-and-status-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 2px;
}

.status-activity-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  color: #e2e8f0;
}

.profile-inline-badges {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.inline-badge-icon {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mutual Servers Row */
.profile-mutual-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  padding: 6px 0;
}

.profile-mutual-icons {
  display: flex;
  align-items: center;
}

.mutual-server-icon,
.mutual-server-initial {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--bg-primary);
  margin-left: -6px;
  object-fit: cover;
  background: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  color: #ffffff;
}

.profile-mutual-icons > :first-child {
  margin-left: 0;
}

.profile-mutual-text {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

/* Dynamic Roles Section */
.roles-section {
  position: relative;
}

.roles-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.role-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  font-size: 12px;
  font-weight: 600;
  color: #f1f5f9;
  transition: all 0.15s ease;
}

.role-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.role-name {
  white-space: nowrap;
}

.role-tag.owner-tag {
  border-color: rgba(251, 191, 36, 0.35);
  background: rgba(251, 191, 36, 0.1);
  color: #fbbf24;
}

.role-tag-remove {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin-left: 2px;
  border-radius: 4px;
  transition: all 0.15s;
}

.role-tag-remove:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.role-add-container {
  position: relative;
  display: inline-block;
}

.role-add-btn {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px dashed rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.05);
  color: #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.role-add-btn:hover,
.role-add-btn.active {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}

.role-picker-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 6px;
  background: #18191c;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 6px;
  z-index: 1000;
  min-width: 190px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
}

.role-picker-header {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #94a3b8;
  padding: 4px 8px;
  letter-spacing: 0.5px;
}

.role-picker-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.role-picker-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #e2e8f0;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;
}

.role-picker-item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.role-picker-empty {
  padding: 8px;
  font-size: 12px;
  color: #64748b;
  text-align: center;
}

/* Quick DM Input at Bottom */
.profile-quick-dm-container {
  margin-top: 16px;
  padding-top: 10px;
}

.profile-quick-dm-form {
  display: flex;
  align-items: center;
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 12px;
  gap: 8px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.profile-quick-dm-form:focus-within {
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
}

.profile-quick-dm-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 13px;
}

.profile-quick-dm-input::placeholder {
  color: #64748b;
}

.profile-quick-dm-actions {
  display: flex;
  align-items: center;
}

.quick-dm-emoji-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  transition: color 0.15s;
}

.quick-dm-emoji-btn:hover {
  color: #fbbf24;
}

.quick-dm-success-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease;
}

/* MySpace Style Profile Anthem (Profil Arka Plan Müziği) */
.profile-anthem-card {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(255, 85, 0, 0.18) 0%, rgba(99, 102, 241, 0.15) 50%, rgba(15, 23, 42, 0.85) 100%);
  border: 1px solid rgba(255, 120, 40, 0.35);
  box-shadow: 0 4px 20px rgba(255, 85, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  padding: 12px 14px;
  margin-bottom: 14px;
  overflow: hidden;
  transition: all 0.25s ease;
}

.profile-anthem-card:hover {
  border-color: rgba(255, 120, 40, 0.6);
  box-shadow: 0 6px 24px rgba(255, 85, 0, 0.2);
}

.profile-anthem-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.profile-anthem-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.8px;
  color: #ff7722;
  text-transform: uppercase;
}

.profile-anthem-badge svg {
  animation: pulseBadge 2s infinite ease-in-out;
}

@keyframes pulseBadge {
  0%, 100% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.15); opacity: 1; }
}

.profile-anthem-tag {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: #cbd5e1;
}

.profile-anthem-body {
  display: flex;
  align-items: center;
  gap: 12px;
}

.anthem-disc-cover {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.anthem-disc-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.anthem-disc-cover.spinning {
  animation: spinDisc 4s linear infinite;
}

@keyframes spinDisc {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.anthem-disc-cover::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #0f172a;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.profile-anthem-meta {
  flex: 1;
  min-width: 0;
}

.profile-anthem-title {
  font-size: 14px;
  font-weight: 800;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 0 2px 0;
}

.profile-anthem-artist {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-anthem-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.anthem-play-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ff5500;
  border: none;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s, background 0.15s, box-shadow 0.15s;
  box-shadow: 0 2px 10px rgba(255, 85, 0, 0.4);
}

.anthem-play-btn:hover {
  background: #ff6a1a;
  transform: scale(1.08);
  box-shadow: 0 4px 14px rgba(255, 85, 0, 0.6);
}

.anthem-play-btn:active {
  transform: scale(0.95);
}

.anthem-external-link {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.15s;
}

.anthem-external-link:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}



`, "",{"version":3,"sources":["webpack://./src/components/UserProfilePanel/UserProfilePanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yFAAyF;EACzF,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sEAAsE;AACxE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,yCAAyC;AAC3C;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,wCAAwC;EACxC,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,6FAA6F;EAC7F,0CAA0C;EAC1C,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yHAAyH;EACzH,0CAA0C;EAC1C,qFAAqF;EACrF,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW,mBAAmB,EAAE,YAAY,EAAE;EAC9C,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+DAA+D;EAC/D,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB","sourcesContent":[".user-profile-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.7);\n  backdrop-filter: blur(10px);\n  z-index: 2000;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.user-profile-panel {\n  width: 440px;\n  height: 100vh;\n  background-color: var(--bg-primary);\n  border-left: 1px solid var(--glass-border);\n  display: flex;\n  flex-direction: column;\n  box-shadow: -20px 0 50px rgba(0, 0, 0, 0.4);\n  position: relative;\n  overflow: hidden;\n}\n\n.user-profile-panel::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.1), transparent);\n  z-index: 100;\n}\n\n.profile-content-scrollable {\n  flex: 1;\n  overflow-y: auto;\n  scrollbar-width: none;\n  position: relative;\n}\n\n.profile-content-scrollable::-webkit-scrollbar {\n  display: none;\n}\n\n.profile-header {\n  position: relative;\n  height: 180px;\n  width: 100%;\n}\n\n.profile-banner {\n  width: 100%;\n  height: 100%;\n  background-color: var(--bg-tertiary);\n  overflow: hidden;\n  position: relative;\n}\n\n.banner-gradient {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.banner-gradient::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom, transparent, var(--bg-primary));\n}\n\n.profile-close-btn {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  width: 40px;\n  height: 40px;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 14px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  z-index: 500;\n}\n\n.profile-close-btn:hover {\n  background-color: var(--brand-primary);\n  transform: rotate(90deg) scale(1.1);\n}\n\n.avatar-positioning {\n  margin-top: -70px;\n  margin-bottom: 28px;\n  padding: 0 32px;\n  position: relative;\n  z-index: 10;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.profile-badges-box {\n  display: flex;\n  gap: 8px;\n  padding-bottom: 12px;\n}\n\n.profile-badge-item {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  cursor: help;\n  transition: all 0.2s;\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.profile-badge-item:hover {\n  transform: translateY(-2px);\n  filter: brightness(1.2);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n\n.profile-avatar-container {\n  width: 140px;\n  height: 140px;\n  position: relative;\n}\n\n.avatar-main {\n  width: 100%;\n  height: 100%;\n  border-radius: 40px;\n  background: var(--bg-primary);\n  border: 6px solid var(--bg-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  font-size: 56px;\n  font-weight: 900;\n  color: var(--brand-light);\n  box-shadow: var(--shadow-xl);\n}\n\n.status-pill-large {\n  position: absolute;\n  bottom: 12px;\n  right: 0px;\n  width: 32px;\n  height: 32px;\n  border-radius: 12px;\n  border: 6px solid var(--bg-primary);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.profile-info-card {\n  display: flex;\n  flex-direction: column;\n  padding: 0 32px 40px;\n}\n\n.name-and-tag {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.display-name {\n  font-size: 28px;\n  font-weight: 900;\n  color: var(--text-primary);\n}\n\n.discriminator {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-muted);\n  opacity: 0.5;\n}\n\n.status-quote {\n  background-color: var(--bg-secondary);\n  border-left: 4px solid var(--brand-primary);\n  padding: 16px 20px;\n  border-radius: 6px 16px 16px 6px;\n  margin-bottom: 28px;\n}\n\n.profile-actions-row {\n  display: flex;\n  gap: 14px;\n  margin-bottom: 40px;\n}\n\n.primary-action-btn {\n  flex: 1;\n  height: 48px;\n  background-color: var(--brand-primary);\n  border: none;\n  border-radius: 14px;\n  color: white;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.secondary-action-btn {\n  width: 48px;\n  height: 48px;\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--glass-border);\n  border-radius: 14px;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.info-divider {\n  height: 1px;\n  background: linear-gradient(to right, var(--glass-border), transparent);\n  margin: 20px 0;\n}\n\n.profile-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.section-label {\n  font-size: 11px;\n  font-weight: 900;\n  color: var(--brand-primary);\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.activity-widget {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 16px;\n  margin-top: 10px;\n}\n\n.activity-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.activity-icon-box {\n  color: #1db954; /* Spotify Green */\n  display: flex;\n  align-items: center;\n}\n\n.activity-title {\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #f8fafc;\n}\n\n.activity-body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.activity-name {\n  font-weight: 900;\n  font-size: 16px;\n  color: #ffffff;\n}\n\n.activity-sub {\n  font-size: 14px;\n  color: #e2e8f0;\n}\n\n.activity-state {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.activity-progress-area {\n  margin-top: 12px;\n}\n\n.progress-track {\n  height: 4px;\n  background: #334155;\n  border-radius: 2px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #1db954;\n  border-radius: 2px;\n}\n\n.progress-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  font-family: 'JetBrains Mono', monospace;\n  color: #94a3b8;\n}\n\n\n.profile-meta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.meta-item {\n  padding: 16px;\n  background-color: var(--bg-tertiary);\n  border: 1px solid var(--glass-border);\n  border-radius: 16px;\n}\n\n.meta-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.meta-label {\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  opacity: 0.7;\n}\n\n.meta-value {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.profile-note-pad {\n  height: 100px;\n  background-color: var(--bg-tertiary);\n  border: 1px solid var(--glass-border);\n  border-radius: 16px;\n  padding: 16px;\n}\n\n/* User Card Connections styling */\n.profile-connections-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.profile-connection-pill {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--glass-border);\n  transition: all var(--transition-fast);\n}\n\n.profile-connection-pill:hover {\n  background: var(--bg-modifier-hover);\n  transform: translateY(-1px);\n}\n\n.profile-connection-pill .platform-name {\n  font-weight: 750;\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n.profile-connection-pill .platform-user {\n  margin-left: auto;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n/* Platform Colors for Icons */\n.profile-connection-pill.spotify {\n  border-left: 3px solid #1db954;\n}\n.profile-connection-pill.spotify svg {\n  color: #1db954;\n}\n\n.profile-connection-pill.soundcloud {\n  border-left: 3px solid #ff5500;\n  background: rgba(255, 85, 0, 0.08);\n}\n.profile-connection-pill.soundcloud:hover {\n  background: rgba(255, 85, 0, 0.16);\n  transform: translateY(-1px);\n}\n.profile-connection-pill.soundcloud svg {\n  color: #ff5500;\n}\n\n.profile-connection-pill.steam {\n  border-left: 3px solid #66c0f4;\n}\n.profile-connection-pill.steam svg {\n  color: #66c0f4;\n}\n\n.profile-connection-pill.epic {\n  border-left: 3px solid #ffffff;\n}\n.profile-connection-pill.epic svg {\n  color: #ffffff;\n}\n\n.profile-connection-pill.flexable {\n  border-left: 3px solid #8b5cf6;\n  background: rgba(139, 92, 246, 0.1);\n  transition: all 0.2s ease;\n}\n.profile-connection-pill.flexable:hover {\n  background: rgba(139, 92, 246, 0.2);\n  transform: translateY(-1px);\n}\n.profile-connection-pill.flexable svg {\n  color: #a78bfa;\n}\n\n.profile-connection-pill.discord {\n  border-left: 3px solid #5865f2;\n  background: rgba(88, 101, 242, 0.08);\n  transition: all 0.2s ease;\n}\n.profile-connection-pill.discord:hover {\n  background: rgba(88, 101, 242, 0.16);\n  transform: translateY(-1px);\n}\n.profile-connection-pill.discord svg {\n  color: #5865f2;\n}\n\n/* Lanyard Discord Activity Widget */\n.lanyard-discord-widget {\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(88, 101, 242, 0.16) 0%, rgba(15, 23, 42, 0.85) 100%);\n  border: 1px solid rgba(88, 101, 242, 0.35);\n  box-shadow: 0 4px 18px rgba(88, 101, 242, 0.12);\n  padding: 12px 14px;\n  margin-bottom: 12px;\n  transition: all 0.2s ease;\n}\n\n.lanyard-discord-widget:hover {\n  border-color: rgba(88, 101, 242, 0.55);\n}\n\n.lanyard-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.lanyard-title-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.8px;\n  color: #5865f2;\n  text-transform: uppercase;\n}\n\n.lanyard-status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.lanyard-status-pill.online {\n  background: rgba(34, 197, 94, 0.18);\n  color: #22c55e;\n}\n.lanyard-status-pill.idle {\n  background: rgba(234, 179, 8, 0.18);\n  color: #eab308;\n}\n.lanyard-status-pill.dnd {\n  background: rgba(239, 68, 68, 0.18);\n  color: #ef4444;\n}\n.lanyard-status-pill.offline {\n  background: rgba(148, 163, 184, 0.18);\n  color: #94a3b8;\n}\n\n/* User Profile Handle and Status Pill */\n.display-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.handle-and-status-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.status-activity-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #e2e8f0;\n}\n\n.profile-inline-badges {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.inline-badge-icon {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Mutual Servers Row */\n.profile-mutual-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 12px;\n  padding: 6px 0;\n}\n\n.profile-mutual-icons {\n  display: flex;\n  align-items: center;\n}\n\n.mutual-server-icon,\n.mutual-server-initial {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid var(--bg-primary);\n  margin-left: -6px;\n  object-fit: cover;\n  background: #334155;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.profile-mutual-icons > :first-child {\n  margin-left: 0;\n}\n\n.profile-mutual-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n/* Dynamic Roles Section */\n.roles-section {\n  position: relative;\n}\n\n.roles-cloud {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.role-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  font-size: 12px;\n  font-weight: 600;\n  color: #f1f5f9;\n  transition: all 0.15s ease;\n}\n\n.role-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.role-name {\n  white-space: nowrap;\n}\n\n.role-tag.owner-tag {\n  border-color: rgba(251, 191, 36, 0.35);\n  background: rgba(251, 191, 36, 0.1);\n  color: #fbbf24;\n}\n\n.role-tag-remove {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  margin-left: 2px;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n\n.role-tag-remove:hover {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.role-add-container {\n  position: relative;\n  display: inline-block;\n}\n\n.role-add-btn {\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  border: 1px dashed rgba(255, 255, 255, 0.25);\n  background: rgba(255, 255, 255, 0.05);\n  color: #cbd5e1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.role-add-btn:hover,\n.role-add-btn.active {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #ffffff;\n}\n\n.role-picker-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 6px;\n  background: #18191c;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  padding: 6px;\n  z-index: 1000;\n  min-width: 190px;\n  max-height: 200px;\n  overflow-y: auto;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);\n}\n\n.role-picker-header {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #94a3b8;\n  padding: 4px 8px;\n  letter-spacing: 0.5px;\n}\n\n.role-picker-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.role-picker-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  color: #e2e8f0;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s;\n}\n\n.role-picker-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n.role-picker-empty {\n  padding: 8px;\n  font-size: 12px;\n  color: #64748b;\n  text-align: center;\n}\n\n/* Quick DM Input at Bottom */\n.profile-quick-dm-container {\n  margin-top: 16px;\n  padding-top: 10px;\n}\n\n.profile-quick-dm-form {\n  display: flex;\n  align-items: center;\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 8px 12px;\n  gap: 8px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.profile-quick-dm-form:focus-within {\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);\n}\n\n.profile-quick-dm-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #ffffff;\n  font-size: 13px;\n}\n\n.profile-quick-dm-input::placeholder {\n  color: #64748b;\n}\n\n.profile-quick-dm-actions {\n  display: flex;\n  align-items: center;\n}\n\n.quick-dm-emoji-btn {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  transition: color 0.15s;\n}\n\n.quick-dm-emoji-btn:hover {\n  color: #fbbf24;\n}\n\n.quick-dm-success-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.2s ease;\n}\n\n/* MySpace Style Profile Anthem (Profil Arka Plan Müziği) */\n.profile-anthem-card {\n  position: relative;\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(255, 85, 0, 0.18) 0%, rgba(99, 102, 241, 0.15) 50%, rgba(15, 23, 42, 0.85) 100%);\n  border: 1px solid rgba(255, 120, 40, 0.35);\n  box-shadow: 0 4px 20px rgba(255, 85, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  padding: 12px 14px;\n  margin-bottom: 14px;\n  overflow: hidden;\n  transition: all 0.25s ease;\n}\n\n.profile-anthem-card:hover {\n  border-color: rgba(255, 120, 40, 0.6);\n  box-shadow: 0 6px 24px rgba(255, 85, 0, 0.2);\n}\n\n.profile-anthem-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.profile-anthem-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.8px;\n  color: #ff7722;\n  text-transform: uppercase;\n}\n\n.profile-anthem-badge svg {\n  animation: pulseBadge 2s infinite ease-in-out;\n}\n\n@keyframes pulseBadge {\n  0%, 100% { transform: scale(1); opacity: 0.9; }\n  50% { transform: scale(1.15); opacity: 1; }\n}\n\n.profile-anthem-tag {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #cbd5e1;\n}\n\n.profile-anthem-body {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.anthem-disc-cover {\n  position: relative;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.anthem-disc-cover img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.anthem-disc-cover.spinning {\n  animation: spinDisc 4s linear infinite;\n}\n\n@keyframes spinDisc {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.anthem-disc-cover::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #0f172a;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.profile-anthem-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.profile-anthem-title {\n  font-size: 14px;\n  font-weight: 800;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0 0 2px 0;\n}\n\n.profile-anthem-artist {\n  font-size: 12px;\n  font-weight: 600;\n  color: #94a3b8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.profile-anthem-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.anthem-play-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #ff5500;\n  border: none;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: transform 0.15s, background 0.15s, box-shadow 0.15s;\n  box-shadow: 0 2px 10px rgba(255, 85, 0, 0.4);\n}\n\n.anthem-play-btn:hover {\n  background: #ff6a1a;\n  transform: scale(1.08);\n  box-shadow: 0 4px 14px rgba(255, 85, 0, 0.6);\n}\n\n.anthem-play-btn:active {\n  transform: scale(0.95);\n}\n\n.anthem-external-link {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  transition: all 0.15s;\n}\n\n.anthem-external-link:hover {\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
